import React from 'react';
import { Shield, Clock, RefreshCw, AlertTriangle, HardDrive, CheckCircle2 } from 'lucide-react';
import './WebsiteDevelopment.css';
import Hero from '../../components/Hero/Hero';
import FAQ from '../../components/FAQ/FAQ';
import CTASection from '../../components/CTA/CTA';
import Footer from '../../components/Footer/Footer';

export default function WebsiteMaintenance() {
  const features = [
    {
      icon: <Shield size={24} />,
      title: 'Security Patches',
      text: 'Continuous monitoring and rapid deployment of security updates to protect your data.'
    },
    {
      icon: <Clock size={24} />,
      title: 'Uptime Monitoring',
      text: '24/7 surveillance of your website performance with instant incident response.'
    },
    {
      icon: <RefreshCw size={24} />,
      title: 'Regular Backups',
      text: 'Automated daily backups stored in secure, off-site locations for peace of mind.'
    }
  ];

  const faqItems = [
    {
      question: 'What is included in the maintenance plan?',
      answer: 'Our plan includes security updates, performance optimization, daily backups, and minor content updates.'
    },
    {
      question: 'How often are backups performed?',
      answer: 'We perform full backups daily and database backups every 6 hours.'
    }
  ];

  return (
    <article className="website-page">
      <Hero 
        eyebrow="Maintenance & Updates"
        title={<>Worry-free <span className="hero-accent">Performance</span> & Security.</>}
        description="Focus on your business while we handle the technical heavy lifting. We keep your website fast, secure, and always up to date."
        primaryAction={{ label: "View Plans", link: "#services" }}
        stats={[
          { label: "Uptime", value: "99.9% Guaranteed" },
          { label: "Support", value: "24/7 Response" }
        ]}
      />

      <section className="section" id="services">
        <div className="section-heading">
          <span className="eyebrow">Services</span>
          <h2>Professional Maintenance.</h2>
          <p>Don't let outdated software slow down your growth. Our maintenance services ensure your site remains a high-performing asset.</p>
        </div>
        <div className="features-grid">
          {features.map((f, i) => (
            <div key={i} className="feature-card">
              <div className="feature-icon">{f.icon}</div>
              <h3>{f.title}</h3>
              <p>{f.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section">
        <div className="info-row reverse">
          <div className="info-copy">
            <h3>Proactive Security</h3>
            <p>We don't wait for things to break. Our regular audits identify potential vulnerabilities before they can be exploited.</p>
            <ul className="check-list">
              <li><CheckCircle2 size={18} /> Malware scanning</li>
              <li><CheckCircle2 size={18} /> Vulnerability assessment</li>
              <li><CheckCircle2 size={18} /> Core/Plugin updates</li>
            </ul>
          </div>
          <div className="info-media">
            <img src="/images/website-maintenance/maintenance.jpg" alt="Maintenance" />
          </div>
        </div>
      </section>

      <section className="section">
        <div className="section-heading">
          <span className="eyebrow">Deep Dive</span>
          <h2>Common Questions.</h2>
        </div>
        <FAQ items={faqItems} />
      </section>

      <CTASection title="Protect your investment today." />
      <Footer />
    </article>
  );
}
